import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ContactMemoApi = /** @class */ (function () {
    function ContactMemoApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ContactMemoApi.initialize = function (basePath, fetchApi) {
        if (!ContactMemoApi.instance) {
            ContactMemoApi.instance = new ContactMemoApi(basePath, fetchApi);
        }
        return ContactMemoApi.instance;
    };
    ContactMemoApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ContactMemoApi(new Configuration(config));
    };
    return ContactMemoApi;
}());
export { ContactMemoApi };
